import moment from 'moment'
import { workerScript } from './search-worker'

export default async function getDateRange(
  metric: string,
  from: string,
  to: string,
): Promise<any> {
  const len = 1000
  const dates: any = []
  const dateTimes: any = []
  const metrics: any = []
  const anomalyHistory: any = {}

  for (let i = 0; i < len; i += 1) {
    const expected = parseInt(`${Math.random() * 10}`, 10)
    const actual = parseInt(`${Math.random() * 10}`, 10)
    const date = moment()
      .subtract(i === 0 ? 0 : -i, 'days')
      .format('DD/MM/YYYY')
    metrics.push(actual)
    dates.push(date)
    dateTimes.push(moment(date, 'DD/MM/YYYY').unix())

    if (actual > expected + 5 || actual < expected - 5) {
      anomalyHistory[date] = {
        date,
        id: `${moment(date, 'DD/MM/YYYY').format('YYYYMMDD')};${metric}`,
        actual,
        expected,
      }
    }
  }

  return new Promise((resolve): void => {
    const worker = new Worker(workerScript)
    worker.addEventListener(
      'message',
      (e): void => {
        const anomalies: [] = e.data.dates
          .map((date: string): any =>
            anomalyHistory[date] ? anomalyHistory[date] : null,
          )
          .filter((a: any): any => a !== null)
        resolve(
          JSON.stringify({
            data: {
              anomalyRange: {
                metricType: metric,
                ...e.data,
                anomalies,
              },
            },
          }),
        )
      },
      false,
    )

    worker.postMessage({
      start: moment(to, 'DD-MM-YYYY').unix(),
      end: moment(from, 'DD-MM-YYYY').unix(),
      dates,
      dateTimes,
      metrics,
    })
  })
}
